import { featureRoute } from '../helpers';

import { SeasonStages } from '../../constants/AppConstants';
import SeasonSearchActions from '../../actions/SeasonSearchActions';

module.exports = featureRoute('enableSeasonTickets', SeasonStages.SEARCH, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/seasonTicket/SeasonSearchForm').default);
        }, 'season-search');
    },

    async onEnter(nextState) {
        const { query } = nextState.location;

        if (query.promoCode) {
            // pre fill and pre validate promo input on the main page if there's promoCode query param
            SeasonSearchActions.preFillPromoFromQuery(query);
        }
    },
});



// WEBPACK FOOTER //
// ./src/routes/Season/Search.js